var styleDataHash = "d334faf1";
const injectCss = (() => {
  var css = `@charset "UTF-8";.D7804,.ReactModalPortal,.glob_fontElementMap,.j4Qgt,button{font-family:var(--ricos-font-family,unset)}.-LXoK{display:flex}.Wu3jQ:hover{box-shadow:0 0 0 2px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}.TEKo7,.Wu3jQ:hover{border-radius:var(--ricos-native-whitebox-border-radius,0);cursor:default}.TEKo7{box-shadow:0 0 0 1px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}.nkJmG .TEKo7{box-shadow:none!important}._7vWHn{cursor:move;display:block;height:100%;left:0;position:absolute;top:0;width:100%}._7vWHn._0Toat{pointer-events:none}.x0Viw ::selection{background:transparent}.p--F0{display:none}.D7804{position:relative}.gP3v3{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{direction:ltr;font-weight:300}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif)}.VoDli{color:#333;text-decoration:none}.CLmgI{display:block}.TAADc{position:relative}._17ERz{margin-left:-20px;margin-right:-20px;overflow-x:auto;overflow-y:hidden}._17ERz.G662t::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}._17ERz.Hc8kc::-webkit-scrollbar-thumb{background-color:transparent}.s9epW{max-width:max-content!important;min-width:100%}._17ERz::-webkit-scrollbar{-webkit-appearance:none}._17ERz::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}._17ERz::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "fontElementMap": "j4Qgt",
  "pluginContainer": "D7804",
  "flex": "-LXoK",
  "isFocusable": "Wu3jQ",
  "hasFocus": "TEKo7",
  "dragImageView": "nkJmG",
  "overlay": "_7vWHn",
  "noPointerEventsOnFocus": "_0Toat",
  "hideTextSelection": "x0Viw",
  "hidden": "p--F0",
  "pluginContainerMobile": "gP3v3",
  "isImage": "VoDli",
  "anchor": "CLmgI",
  "horizontalScrollbarWrapper": "TAADc",
  "pluginWithHorizontalScrollbar": "_17ERz",
  "show": "G662t",
  "hide": "Hc8kc",
  "horizontalScrollbar": "s9epW"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
